<!-- 雇用形態選択スライド -->
<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';

import type Inquiry from '@/javascripts/utils/inquiry';
import { getEmploymentTypes } from '@/javascripts/utils/inquiry_form_options';

import type { InquiryValidation } from '@/javascripts/composables/inquiry/validation';

/** プロパティ */
const props = defineProps<{
  /** 問い合わせオブジェクト */
  employmentTypeCd: Inquiry['employmentTypeCd'],
  /** 問い合わせバリデーション */
  v$: InquiryValidation,
}>();

/** カスタムイベント */
const emit = defineEmits([
  'next', 
  'update:employment-type-cd'
]);

/** フォーム項目の computed プロパティ */
const localEmploymentTypeCd = computed({
  get: () => props.employmentTypeCd,
  set: (value) => emit('update:employment-type-cd', value)
});

/** 雇用形態の選択肢リスト */
const employmentTypes = getEmploymentTypes();

/** 「次へ」ボタン */
const nextButton = ref<HTMLButtonElement | null>();

/** 雇用形態のバリデーション結果 */
const invalid = computed(() => props.v$.employmentTypeCd.$invalid);

// 雇用形態変更時にエラーがなければ`next`イベントを発火
watch(localEmploymentTypeCd, async () => {
  if(!invalid.value) {
    // 「次へ」ボタンが有効になるのを待つ
    await nextTick();

    nextButton.value?.click();
  }
});
</script>

<template>
  <div class="slide_body">
    <div class="option_wrap">
      <h3 class="option_title required">
        どのような働き方をご希望ですか？
      </h3>
      <div class="option_group">
        <div
          v-for="employmentType in employmentTypes"
          :key="employmentType.cd"
          class="option_input"
        >
          <input
            :id="`employment_type_cd_${employmentType.cd}`"
            v-model="localEmploymentTypeCd"
            type="radio"
            name="employment_type"
            :value="employmentType.cd"
            required
          >
          <label
            :for="`employment_type_cd_${employmentType.cd}`"
          >{{ employmentType.text }}</label>
        </div>
      </div>
      <div
        v-for="(error, index) in v$.employmentTypeCd.$errors"
        :key="index"
        class="validation_message_box"
      >
        {{ error.$message }}
      </div>
    </div>
    <div class="slide_control_group">
      <button
        id="ph_next_1"
        ref="nextButton"
        :disabled="invalid"
        class="form_button"
        @click="emit('next')"
      >
        次へ
      </button>
    </div>
  </div>
</template>